// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moduleHeader__wrapper {
	position: relative;
	top: 0;
	height: 100%;
	max-width: 1440px;
	display: contents;
	margin: 0;
	padding: 0;
	overflow: hidden
}
.activeTab{
	background: linear-gradient(135deg, #00d5fd 0%, #0495ff 50%, #0072ee 100%) !important;
	color: #ffffff !important;
	border-bottom: none;
	border-radius: 4px 4px 0 0;
	box-shadow: 0 4px 12px rgba(0, 180, 220, 0.35);
	transition: all 0.2s ease;
}
.moduleHeader__row {
	height: auto;
	width: 100%;
	position: relative;
	z-index: 10;
	padding: 2px 0;
}
.moduleSubHeader {
	background: #ffffff;
}
.moduleSubHeader .horizontalNavigation {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-wrap: nowrap;
	flex-direction: row;
	padding: 0 32px;
	margin-top: 10px;
}
@media (min-height: 766px) {
	.moduleSubHeader .horizontalNavigationShadow {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: nowrap;
		flex-direction: row;
	}
}
.moduleSubHeader .horizontalNavigation__list {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	flex-direction: row;
	margin: 0;
	padding: 0;
	gap: 4px;
}
.moduleSubHeader .horizontalNavigation__list-item {
	list-style-type: none;
	width: 170px;
	text-align: center;
	outline: none;
	border: 1px solid #a0d8ef;
	background: linear-gradient(135deg, #e8f7fc 0%, #cdf0f8 100%);
	border-radius: 4px 4px 0 0;
	margin-right: 0;
	transition: background 0.2s ease;
}
.moduleSubHeader .horizontalNavigation__list-item:focus {
	outline: none;
}
.moduleSubHeader .horizontalNavigation__list-item:hover{
	background: linear-gradient(135deg, #c8eef8 0%, #a0e0f5 100%);
}
.moduleSubHeader .navigation__link {
	width: inherit;
	margin: 0;
	background: none;
	border-radius: 0;
	border: 0;
	position: relative;
	display: inline-block;
	height: 100%;
	letter-spacing: 0;
	line-height: 44px;
}
.navigation__link:focus {
	outline: none;
}
.moduleSubHeader .navigation__link-text{
	font-weight: 500;
	font-size: var(--subheader);
	line-height: 20px;
	font-family: "Segoe UI" !important;
	color: #2a3a42;
	transition: color 0.2s ease;
}
.activeTab .navigation__link-text {
	color: #ffffff !important;
	font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/SubHeaderStyles.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,MAAM;CACN,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;CACjB,SAAS;CACT,UAAU;CACV;AACD;AACA;CACC,qFAAqF;CACrF,yBAAyB;CACzB,mBAAmB;CACnB,0BAA0B;CAC1B,8CAA8C;CAC9C,yBAAyB;AAC1B;AACA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,iBAAiB;CACjB,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC;EACC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;CACpB;AACD;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,mBAAmB;CACnB,SAAS;CACT,UAAU;CACV,QAAQ;AACT;AACA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,yBAAyB;CACzB,6DAA6D;CAC7D,0BAA0B;CAC1B,eAAe;CACf,gCAAgC;AACjC;AACA;CACC,aAAa;AACd;AACA;CACC,6DAA6D;AAC9D;AACA;CACC,cAAc;CACd,SAAS;CACT,gBAAgB;CAChB,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,iBAAiB;CACjB,kCAAkC;CAClC,cAAc;CACd,2BAA2B;AAC5B;AACA;CACC,yBAAyB;CACzB,gBAAgB;AACjB","sourcesContent":[".moduleHeader__wrapper {\n\tposition: relative;\n\ttop: 0;\n\theight: 100%;\n\tmax-width: 1440px;\n\tdisplay: contents;\n\tmargin: 0;\n\tpadding: 0;\n\toverflow: hidden\n}\n.activeTab{\n\tbackground: linear-gradient(135deg, #00d5fd 0%, #0495ff 50%, #0072ee 100%) !important;\n\tcolor: #ffffff !important;\n\tborder-bottom: none;\n\tborder-radius: 4px 4px 0 0;\n\tbox-shadow: 0 4px 12px rgba(0, 180, 220, 0.35);\n\ttransition: all 0.2s ease;\n}\n.moduleHeader__row {\n\theight: auto;\n\twidth: 100%;\n\tposition: relative;\n\tz-index: 10;\n\tpadding: 2px 0;\n}\n.moduleSubHeader {\n\tbackground: #ffffff;\n}\n.moduleSubHeader .horizontalNavigation {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-wrap: nowrap;\n\tflex-direction: row;\n\tpadding: 0 32px;\n\tmargin-top: 10px;\n}\n@media (min-height: 766px) {\n\t.moduleSubHeader .horizontalNavigationShadow {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\tflex-wrap: nowrap;\n\t\tflex-direction: row;\n\t}\n}\n.moduleSubHeader .horizontalNavigation__list {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tflex-direction: row;\n\tmargin: 0;\n\tpadding: 0;\n\tgap: 4px;\n}\n.moduleSubHeader .horizontalNavigation__list-item {\n\tlist-style-type: none;\n\twidth: 170px;\n\ttext-align: center;\n\toutline: none;\n\tborder: 1px solid #a0d8ef;\n\tbackground: linear-gradient(135deg, #e8f7fc 0%, #cdf0f8 100%);\n\tborder-radius: 4px 4px 0 0;\n\tmargin-right: 0;\n\ttransition: background 0.2s ease;\n}\n.moduleSubHeader .horizontalNavigation__list-item:focus {\n\toutline: none;\n}\n.moduleSubHeader .horizontalNavigation__list-item:hover{\n\tbackground: linear-gradient(135deg, #c8eef8 0%, #a0e0f5 100%);\n}\n.moduleSubHeader .navigation__link {\n\twidth: inherit;\n\tmargin: 0;\n\tbackground: none;\n\tborder-radius: 0;\n\tborder: 0;\n\tposition: relative;\n\tdisplay: inline-block;\n\theight: 100%;\n\tletter-spacing: 0;\n\tline-height: 44px;\n}\n.navigation__link:focus {\n\toutline: none;\n}\n.moduleSubHeader .navigation__link-text{\n\tfont-weight: 500;\n\tfont-size: var(--subheader);\n\tline-height: 20px;\n\tfont-family: \"Segoe UI\" !important;\n\tcolor: #2a3a42;\n\ttransition: color 0.2s ease;\n}\n.activeTab .navigation__link-text {\n\tcolor: #ffffff !important;\n\tfont-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
